<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
     Nota Part List
    </v-card-title> -->
    <v-card-title>
      
        <!-- <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
              Add Nota Jasa Bkl
            </v-btn> -->
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    :data="dataExport(table)"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportAllFitered"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <div class="d-flex flex-wrap">
                <!-- filter date -->
                <!-- <div class="shadow d-flex">
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <p class="mt-5 fs-small">s/d</p>
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <v-btn :disabled="!search" class="mt-5" small color="primary">
                    <v-icon>mdi-calendar-filter</v-icon>
                  </v-btn>
                </div> -->
                <v-select
                  style=" max-width: 150px;" 
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search = ''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                  class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn
                  :disabled="!search"
                  class="mt-5"
                  small
                  color="primary"
                  @click="searchButton"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  v-if="searchValue"
                  class="mt-5 ml-1"
                  dark
                  small
                  color="red"
                  @click="clearSearchButton"
                  >Clear</v-btn
                >
              </div>
            </v-card-title>
    <v-data-table
    mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
    >
   
    
    <template v-slot:[`item.plate_no`]="{ item }">
          <span v-if="item.nota_part_pkb.service_estimate.vehicle_types">{{item.nota_part_pkb.service_estimate.vehicle_types.vehicle_plate_no}}</span>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="detailNotaPart(item.id)">
            <v-list-item-title >Detail</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template v-slot:[`header.pool`]="{ header }">
                  <v-select
                    style=" font-size:10px;"
                    :items="optionPool"
                    :label="header.text"
                    v-model="valuePool"
                    @change="getList"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                </template>
     
      <template v-slot:[`item.pool`]="{ item }">
    
        <span >{{ item.nota_part_pkb.service_estimate.pool.pool_name}} </span>
          
      </template>
    
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
  <modal ref="modalDetailPage">
    <template v-slot:body >
      <detail-nota-part :data_id="$refs.modalDetailPage.data" />
    </template>
  </modal>
</div>
</template>
 
<script>
import vuetify from '@/plugins/vuetify'
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";
import DetailNotaPart from "@/pages/Dashboard/Workshop/NotaPart/DetailNPPage.vue";
import { Modal } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage, Modal, "detail-nota-part" : DetailNotaPart
  },
    vuetify,
    data () {
      return {
      user: null,
        page: 1,
        totalDataTable: 0,
        numberOfPages: 0,
        options: {},
        searchValue: null,
        searchCategory: null,
        option_filter: [
          { text: 'Nota No.', value: 'nota_part_no' },
          { text: 'PKB No.', value: 'pkb_no'},
          { text: 'Customer Name', value: 'client_name'},
          { text: 'Customer Phone', value: 'client_phone' },
          { text: 'Plate No.', value: 'plate_no' },
        ],
        loadTable: true,
        role: "",
        search: '',
        headers: [
          // {
          //   text: 'Detail',
          //   align: 'start center',
          //   value: 'detail',
          //   sortable: false
          // },
          {
            text: 'Actions',
            align: 'start center',
            value: 'actions',
            sortable: false
          },
          { text: 'Nota No.', value: 'nota_part_no' },
          { text: 'Nota Date', value: 'nota_part_datetime', width:'120'},
          { text: 'PKB No.', value: 'nota_part_pkb.pkb_no'},
          { text: 'PKB Date', value: 'nota_part_pkb.pkb_datetime', width:'120'},
          { text: 'Customer Name', value: 'nota_part_pkb.service_estimate.client.client_name', width:'200' },
          { text: 'Customer Phone', value: 'nota_part_pkb.service_estimate.client.client_phone' },
          { text: 'Plate No.', value: 'plate_no' },
          { text: 'Mengetahui', value: 'nota_part_mengetahui_name.name' },
          { text: 'Diperiksa', value: 'nota_part_pkb.service_estimate.sa_name.name' },
          { text: 'Created At', value: 'created_at', align: 'center', width:'200'},
        ],
        table: [],
        worksheetName: "Nota Part",
        fileName: "Nota Part.xls",
        exportDisplayedPage: [],
        exportAllFitered: [],
        exportAll: [],
        field_export: {
         'no': 'no',
      'nota_part_no' : 'nota_part_no',
      'nota_part_datetime' : 'nota_part_datetime',
      'nota_part_pool'  : 'nota_part_pool',
      'pkb_no' : 'pkb_no',
      'pkb_datetime' : 'pkb_datetime',
      'client_name' : 'client_name',
      'client_phone' : 'client_phone',
      'client_email' : 'client_email',
      'client_address' : 'client_address',
      'vehicle_plate_no' : 'service_estimate_customer_plate_no',
      'vehicle_chasis_no' : 'service_estimate_chasis_no',
      'vehicle_engine_no' : 'service_estimate_engine_no',
      'vehicle_color' : 'service_estimate_customer_color',
      'vehicle_production_year' : 'service_estimate_customer_year',
      'nota_part_mengetahui' : 'nota_part_mengetahui',
      'nota_part_diperiksa' : 'nota_part_diperiksa',
      'no_part' : 'no_part',
      'spare_part_master_code' : 'spare_part_master_code',
      'spare_part_master_name' : 'spare_part_master_name',
      'spare_part_qty' : 'service_estimate_spare_part_qty',
      'spare_part_master_unit_price' : 'spare_part_master_unit_price',
      'spare_part_discount' : 'service_estimate_spare_part_discount',
      'part_total' : 'part_total',
      'created_at' : 'created_at',
      'updated_at' : 'updated_at'
        },
        
      optionPool: [
            { text: "All", value: "" },
          ],
          valuePool: "",
      }
    },
    // async created() {
    //   //get list role dan permission current user 
    //   this.role = await this.$store.getters["role_permission/route_filter"];
    // this.getList();
    // },
    watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },

    async mounted() {
      //set refs in root saat page terbuka, agar fungsi di page ini bisa di panggil dari page lain
      this.$root.$refs.ListNotaPartPage = this;
      //check saat page terbuka apakah ada params 
      if(this.$route.params.id){
        //open detail
        this.detailNotaPart(this.$route.params.id)
      }
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];

      this.user = await this.$store.getters["profile/me"];
      if(!this.user.pool){
        this.headers.push({ text: "Eshed", value: "pool", sortable: false, width:'120' });
        await this.$store.dispatch("workshop_pool/list");
        await this.$store.getters["workshop_pool/list"].forEach((value, index) => {
          this.optionPool.push({ text: value.pool_name, value:  value.id});
         });
      }
      this.getList();
      this.mounted = false;
    }, 
     methods: {
       // ambil data yang dibutuhkan
       async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

      if(this.valuePool!=''){
        if(query.filter){
          Object.assign(query.filter, {pool:this.valuePool});
        }
        else{
          query.filter = {pool:this.valuePool}
        }
      }

      await this.$store.dispatch("workshop_nota_part/list", query);
      
      this.table = await this.$store.getters["workshop_nota_part/list"];
      var pageMeta = await this.$store.getters["workshop_nota_part/page"];

      console.log(pageMeta);
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },

    detailNotaPart(id){
      this.$refs.modalDetailPage.openModal({id:id})
    },
    modalCloseDetail(){
      this.$refs.modalDetailPage.closeModal();
      this.getList();

    },

    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
    },
     //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    dataExport(data){
      var dataRetrun = []
      data.forEach((value_1, index_1) => {
        // console.log(value_1)
        var pkb= null
        var vehicle_no_plat= null
        var vehicle_colour= null
        var vehicle_production_year= null
        var vehicle_engine_no= null
        var vehicle_chassis_no= null
   
        if(value_1.nota_part_pkb.service_estimate.vehicle_types){
          if(value_1.nota_part_pkb.service_estimate_type == 1){
            if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 0){
              vehicle_colour = "Putih"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 1){
              vehicle_colour = "Putih Kuning"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 2){
              vehicle_colour = "Putih Metalik"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 3){
              vehicle_colour = "Hitam"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 4){
              vehicle_colour = "Hitam Metalik"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 5){
              vehicle_colour = "Silver"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 6){
              vehicle_colour = "Silver Metalik"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 7){
              vehicle_colour = "Abu Abu"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 8){
              vehicle_colour = "Abu Abu Metalik"
            }
            else if(value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color == 9){
              vehicle_colour = "Hijau"
            }
          }
          else if(value_1.nota_part_pkb.service_estimate_type == 2){
            vehicle_colour = value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_body_color
          }
          vehicle_no_plat = value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_plate_no
          vehicle_engine_no = value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_engine_no
          vehicle_chassis_no = value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_chassis_no
         
    
    
          vehicle_production_year = value_1.nota_part_pkb.service_estimate.vehicle_types.vehicle_production_year
        }
        if(value_1.nota_part_pkb){
          pkb = value_1.nota_part_pkb.pkb_no
        }

         var nota_part_mengetahui_name=''
            if(value_1.nota_part_mengetahui_name != null){
              nota_part_mengetahui_name = value_1.nota_part_mengetahui_name.name 
            }
            var nota_part_diperiksa_name=''
            if(value_1.nota_part_diperiksa_name != null){
              nota_part_diperiksa_name = value_1.nota_part_pkb.pkb_service_estimate.sa_name.name
            }
 
      
        if(value_1.nota_part_part.length != 0){
          value_1.nota_part_part.forEach((value_2, index_2) => {
            var no = null
            if(index_2 == 0){
              no = index_1+1
            }
            var discount = 0
            if(value_1.service_estimate_service_discount != null){
              discount = value_1.service_estimate_service_discount 
            }
            var data= {
              'no': no,
              'nota_part_no' : value_1.nota_part_no,
              'nota_part_datetime' : value_1.nota_part_datetime,
              'nota_part_pool'  : value_1.nota_part_pkb.service_estimate.pool.pool_name,
              'pkb_no' : value_1.nota_part_pkb.pkb_no,
              'pkb_datetime' : value_1.nota_part_pkb.pkb_datetime,
              'nota_part_pool'  : value_1.nota_part_pkb.service_estimate.pool.pool_name,
            'client_name' : value_1.nota_part_pkb.service_estimate.client.client_name,
            'client_phone' : value_1.nota_part_pkb.service_estimate.client.client_phone,
            'client_email' : value_1.nota_part_pkb.service_estimate.client.client_email,
            'client_address' : value_1.nota_part_pkb.service_estimate.client.client_address,
              'service_estimate_customer_plate_no' : vehicle_no_plat,
              'service_estimate_chasis_no' : vehicle_chassis_no,
              'service_estimate_engine_no' : vehicle_engine_no,
              'service_estimate_customer_color' : vehicle_colour,
              'service_estimate_customer_year' : vehicle_production_year,
              'nota_part_mengetahui' : nota_part_mengetahui_name,
              'nota_part_diperiksa' : nota_part_diperiksa_name,
              'no_part' : index_2+1,
              'spare_part_master_code' : value_2.spare_part_master_code,
              'spare_part_master_name' : value_2.spare_part_master_name,
              'service_estimate_spare_part_qty' : value_2.pkb_spare_part_qty,
              'spare_part_master_unit_price' : value_2.spare_part_master_unit_price,
              'service_estimate_spare_part_discount' : value_2.pkb_spare_part_discount, 
              'part_total' : (value_2.pkb_spare_part_qty * value_2.spare_part_master_unit_price) - ((value_2.spare_part_master_unit_price * value_2.pkb_spare_part_qty) * value_2.pkb_spare_part_discount / 100),
              'created_at' :  value_1.created_at,
              'updated_at' :  value_1.updated_at
            }
           
              dataRetrun.push(data)
            
          });
              
        }
         
        else{
          var data= {
            'no': index_1+1,
            'nota_part_no' : value_1.nota_part_no,
            'nota_part_datetime' : value_1.nota_part_datetime,
            'pkb_no' : value_1.nota_part_pkb.pkb_no,
            'pkb_datetime' : value_1.nota_part_pkb.pkb_datetime,
              'nota_part_pool'  : value_1.nota_part_pkb.service_estimate.pool.pool_name,
            'client_name' : value_1.nota_part_pkb.service_estimate.client.client_name,
            'client_phone' : value_1.nota_part_pkb.service_estimate.client.client_phone,
            'client_email' : value_1.nota_part_pkb.service_estimate.client.client_email,
            'client_address' : value_1.nota_part_pkb.service_estimate.client.client_address,
           'service_estimate_customer_plate_no' : vehicle_no_plat,
              'service_estimate_chasis_no' : vehicle_chassis_no,
              'service_estimate_engine_no' : vehicle_engine_no,
              'service_estimate_customer_color' : vehicle_colour,
              'service_estimate_customer_year' : vehicle_production_year,
            'nota_part_mengetahui' : nota_part_mengetahui_name,
            'nota_part_diperiksa' : nota_part_diperiksa_name,
            'no_part' : null,
            'spare_part_master_code' : null,
            'spare_part_master_name' : null,
            'service_estimate_spare_part_qty' : null,
            'spare_part_master_unit_price' : null,
            'service_estimate_spare_part_discount' : null,
            'part_total' : null,
            'created_at' :  value_1.created_at,
            'updated_at' :  value_1.updated_at
          }
         
            dataRetrun.push(data)
          
        }
      });
      return dataRetrun
    }



  
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>